@let style = styleSg();
@let text = textSg();
@let selected = selectedSg();
@let color = colorSg();
@let backgroundColor = backgroundColorSg();
@if (text) {
  <div
    class="atn-ds-tag"
    [style.backgroundColor]="backgroundColor"
    [style.color]="color"
    [ngClass]="{
      'atn-ds-tag--selected': selected,
      'atn-ds-tag--primary': style === PredefinedStyleEnum.Primary,
      'atn-ds-tag--secondary': style === PredefinedStyleEnum.Secondary,
      'atn-ds-tag--success': style === PredefinedStyleEnum.Success,
      'atn-ds-tag--info': style === PredefinedStyleEnum.Info,
      'atn-ds-tag--warning': style === PredefinedStyleEnum.Warning,
      'atn-ds-tag--danger': style === PredefinedStyleEnum.Danger,
      'atn-ds-tag--transparent': style === PredefinedStyleEnum.Transparent,
      'atn-ds-tag--white': style === PredefinedStyleEnum.White,
    }"
    (click)="clickHandler()"
  >
    <span> {{ text }} </span>

    @if (close.observed) {
      <span
        class="atn-ds-tag__close-icon"
        (click)="close.emit()"
      >
        x
      </span>
    }
  </div>
}
